export default "__VITE_ASSET__65dda179__"